function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "primary/edit",
  transform: "translate(-1.000000, 0.000000)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2.5576923,21.9423077 L1.34615385,27.9999999 C1.21153846,28.4038461 1.34615385,28.9423078 1.75,29.2115384 C2.01923077,29.4807692 2.28846154,29.6153845 2.6923077,29.6153845 L2.96153845,29.6153845 L9.01923076,28.4038461 L2.5576923,21.9423077 Z",
  id: "Shape"
}), React.createElement("rect", {
  id: "Rectangle-path",
  transform: "translate(14.855016, 16.201440) rotate(-45.000000) translate(-14.855016, -16.201440) ",
  x: 4.75895908,
  y: 11.0187974,
  width: 20.1921141,
  height: 10.3652852
}), React.createElement("path", {
  d: "M30.5576924,5.78846153 L25.1730768,0.403846154 C24.6346154,-0.134615385 23.8269231,-0.134615385 23.2884616,0.403846154 L20.1923077,3.50000001 L27.4615385,10.7692308 L30.5576924,7.67307692 C31.0961538,7.13461539 31.0961538,6.32692308 30.5576924,5.78846153 Z",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/edit-icon.80802745.svg";
export { SvgComponent as ReactComponent };